import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { IBreadcrumb } from './../breadcrumb.shared';
import { BreadcrumbService } from './../services/breadcrumb.service';

@Component({
	selector: 'app-breadcrumb',
	template: `
		<div class="row" [class.empty]="(crumbs$ | async).length === 0">
			<div class="col-sm-12">
				@if ((crumbs$ | async).length) {
					<ol class="breadcrumb py-1 ps-0 mb-0">
						@for (
							crumb of crumbs$ | async;
							track crumb;
							let last = $last;
							let first = $first
						) {
							<li
								[class.active]="last"
								[class.ps-4]="first"
								[class.first]="first"
								class="breadcrumb-item"
							>
								@if (first && first !== last) {
									<span style="font-weight: bold">{{
										crumb.text | translate
									}}</span>
								}
								@if (!last && !first) {
									<a [routerLink]="crumb.path">{{
										crumb.text | translate
									}}</a>
								}
								@if (last) {
									<span [class.first]="first">{{
										crumb.text | translate
									}}</span>
								}
							</li>
						}
					</ol>
				}
			</div>
		</div>
	`,
	styleUrls: ['./breadcrumbs.component.scss'],
	standalone: true,
	imports: [RouterLink, AsyncPipe, TranslateModule]
})
export class BreadcrumbComponent {
	/**
	 * DI
	 */
	public service = inject(BreadcrumbService);

	crumbs$: Observable<IBreadcrumb[]> = this.service.crumbs$;
}
